module.exports = __webpack_public_path__ + "static/media/ic_x.b9d823fa.svg";